import React, { useEffect, useState, useContext } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Topbar from "./Topbar";
import { UserContext } from "./UserContext";
import * as XLSX from "xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UserList = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const formatDate = (data) => {
    if (data) {
      let msDate = data;
      let timestamp = parseInt(msDate.match(/\d+/)[0], 10);
      let date = new Date(timestamp);

      let day = String(date.getDate()).padStart(2, "0");
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let year = date.getFullYear(); // full year

      return `${day}-${month}-${year}`;
    } else {
      return "";
    }
  };

  const { userData } = useContext(UserContext);
  const [prData, setPrData] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const [searchText, setSearchText] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedFromDate, setSelectedFromDate] = useState(new Date());
  const [selectedToDate, setSelectedToDate] = useState(new Date());
  const [roles, setRoles] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedData, setSelectedData] = useState({ id: null, email: "" });
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [plant, setPlant] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [role, setRole] = useState("");
  const [reload, setReload] = useState(0);

  // Inside the component, after state declarations
  const exportToExcel = () => {
    if (!filtered || filtered.length === 0) {
      alert("No data to export");
      return;
    }

    const excelData = filtered.map((row, index) => ({
      "#": (currentPage - 1) * rowsPerPage + index + 1,
      "Purchase Order": row.PoText,
      Supplier: row.SuppName,
      Status: row.Status,
      "Approval Status": row.ApprovalStatus,
      Approver: row.Approver,
      "Purchase Order Date": formatDate(row.PurchaseOrderDate),
      "Net Order Value": row.NetAmount,
      "ATTACHMENT UPLOADED?": row.YY1_ATTACH_UPLOADED_PDH,
      "Created By": row.CreatedByUser,
      "Created On": formatDate(row.CreationDate),
      Material: row.Material,
      "Our Reference": row.CorrespncInternalReference,
      Plant: row.Plant,
      Pur_Req_Date: formatDate(row.YY1_Pur_Req_Date_PDH),
      Pur_Req_No: row.YY1_Pur_Req_No_PDH,
      "Quotation Date": formatDate(row.YY1_QuotationDate_PDH),
      "Quotation No": row.YY1_QuotationNo_PDH,
      "Your Reference": row.CorrespncExternalReference,
      "Amendment PO": row.AmendmentPO,
      "Amendment Price": row.YY1_AmPOPrice_PDI,
      "Previous Payment": row.PreviousPayment,
      Outstanding: row.Outstanding,
      Credit: row.PaymentTerms,
      "Advance Payment": row.AdvancePayment,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = { font: { bold: true } };
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PR Report");

    const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
    XLSX.writeFile(workbook, `PR_Report_${ts}.xlsx`);
  };

  const searchRecords = async () => {
    setLoading(true);
    try {
      let fromDate = new Date(selectedFromDate)
        .toLocaleDateString("en-GB")
        .replace(/\//g, "-");
      let toDate = new Date(selectedToDate)
        .toLocaleDateString("en-GB")
        .replace(/\//g, "-");
      const response = await axios.get(baseUrl + "auth/userList", {
        params: {
          user_id: userId,
          fromDate: fromDate,
          toDate: toDate,
        },
        ...config,
      });
      //console.log(response); return false;
      //const data = response.data?.data || [];
      const data =
        response.data?.data.filter(
          (item) => item.Approver === "Dr. SOUMYA RANJAN SAMAL",
        ) || [];
      //console.log(data);
      setPrData(data);
    } catch (error) {
      //console.log(error.response.data.error);
      if (
        error.response.data.error === "login_required" &&
        error.response.data.login_url
      ) {
        //console.log("here"); return false;
        window.location.href = error.response.data.login_url;
        //console.log(data.login_url);
      } else {
        setPrData([]);
      }
    } finally {
      setLoading(false);
    }
  };
  const navigate = useNavigate();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };

  const handleRoleChange = async (userId, newRole) => {
    try {
      await axios.post(
        `${baseUrl}auth/updateRole`,
        {
          user_id: userId,
          role: newRole,
        },
        config,
      );

      // Optionally, update local state so table reflects change
      /* setData((prev) =>
      prev.map((item) =>
        item.id === userId ? { ...item, role: newRole } : item
      )
    ); */
    } catch (error) {
      //console.error("Error updating role:", error);
    }
  };

  const handleStatusChange = async (userId, status) => {
    try {
      await axios.post(
        `${baseUrl}auth/updateStatus`,
        {
          user_id: userId,
          status: status,
        },
        config,
      );

      // Optionally, update local state so table reflects change
      /* setData((prev) =>
      prev.map((item) =>
        item.id === userId ? { ...item, role: newRole } : item
      )
    ); */
    } catch (error) {
      //console.error("Error updating role:", error);
    }
  };

  const updatePassword = async (userId, emaill) => {
    if (!password || password.length < 6) {
      alert("Password must be at least 6 characters");
      return;
    }
    if (password != confirmpassword) {
      alert("Passwords don't not match!");
      return;
    }
    try {
      const response = await axios.post(
        `${baseUrl}auth/updatePassword`,
        {
          user_id: userId,
          email: emaill,
          password: password,
        },
        config,
      );
      alert(`Password changed successfully`);
    } catch (error) {
      //console.error("Error updating role:", error);
    }
  };

    const doRegister = async (userId, emaill) => {
    try {
      const response = await axios.post(
        `${baseUrl}auth/register`,
        {
          name: userName,
          plant: plant,
          status: status,
          role: role,
          email: email,
          //password: password,
        },
        config,
      );
      alert(`User Creation Successful`);
      setReload(r=>r+1);
    } catch (error) {
      //console.error("Error updating role:", error);
    }
  };


  const userTypeLabels = {
    0: "NA",
    1: "EIC",
    2: "Director DP",
    3: "Director HR",
    4: "VP Finance",
    5: "Super Admin",
  };

  useEffect(() => {
    //alert("Hello");
    $("#myModal").modal("toggle");
    const fetchPRs = async () => {
      //console.log("I am called");
      try {
        let fromDate = new Date(selectedFromDate)
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-");
        let toDate = new Date(selectedToDate)
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-");
        const response = await axios.get(baseUrl + "auth/userList", config);
        //console.log(response); return false;
        const data = response.data?.data || [];
        //console.log(data);
        setPrData(data);
      } catch (error) {
        if (
          error.response.data.error === "login_required" &&
          error.response.data.login_url
        ) {
          //console.log("here"); return false;
          window.location.href = error.response.data.login_url;
          //console.log(data.login_url);
        } else {
          setPrData([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPRs();
  }, [reload]);

  useEffect(() => {
    const lower = searchText.toLowerCase();
    const filteredData = prData.filter((pr) => {
      const userName = pr.name?.toLowerCase() || "";
      return userName.includes(lower);
    });

    setFiltered(filteredData);
  }, [searchText, prData]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await axios.get(
          baseUrl + "auth/allRoles?user_id=" + userId,
          config,
        );
        const data1 = response.data?.data || [];
        console.log(data1);
        setRoles(data1);
      } catch (error) {
        setRoles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, []);

  const columns = [
    {
      name: "#",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      width: "60px",
    },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Plant", selector: (row) => row.plant },
    { name: "Email", selector: (row) => row.email },

    {
      name: "Role",
      cell: (row) => (
        <select
          value={row.role}
          onChange={(e) => handleRoleChange(row.id, e.target.value)}
          style={{
            padding: "5px 8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            background: "#fff",
            cursor: "pointer",
          }}
        >
          {roles.map((item, index) => (
            <option value={item.id} key={index}>
              {item.roles}
            </option>
          ))}
        </select>
      ),
    },
    {
      name: "Status",
      cell: (row) => (
        <select
          value={row.status}
          onChange={(e) => handleStatusChange(row.id, e.target.value)}
          style={{
            padding: "5px 8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            background: "#fff",
            cursor: "pointer",
          }}
        >
          <option value={""}>Status</option>
          <option value={1}>Active</option>
          <option value={0}>In-Active</option>
        </select>
      ),
    },
    {
      name: "Password",
      cell: (row) => (
        <button
          onClick={() => {
            setSelectedData({ id: row.id, email: row.email });
            setShowPopup(true);
          }}
          style={{
            padding: "5px 10px",
            border: "none",
            background: "#007bff",
            color: "#fff",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Generate Password
        </button>
      ),
    },
  ];

  return (
    <>
      <Topbar />
      <div className="container">
        <div className="row">
           <form className="form-horizontal form-material text-center" id="loginform"  onSubmit={(e) => {
    e.preventDefault(); // prevent page reload
    doRegister();      // trigger login logic
  }}>
          <div className="card-body">
            <div
              className="form-group m-t-10  col-md-6"
              style={{ float: "left", marginRight: "10px", width: "49%" }}
            >
              <div className="col-md-12">
                <input
                  className="form-control"
                  type="text"
                  required=""
                  placeholder="Name"
                  name="username"
                  onChange={(e) => setUserName(e.target.value)}
                />
              </div>
            </div>
            <div
              className="form-group m-t-10  col-md-6"
              style={{ float: "left" }}
            >
              <div className="col-md-12">
                <input
                  className="form-control"
                  type="text"
                  required=""
                  placeholder="Plant"
                  name="plant"
                  onChange={(e) => setPlant(e.target.value)}
                />
              </div>
            </div>
            <div
              className="form-group m-t-10  col-md-6"
              style={{ float: "left", marginRight: "10px", width: "49%" }}
            >
              <div className="col-md-12">
                <input
                  className="form-control"
                  type="text"
                  required=""
                  placeholder="Email"
                  name="email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>
            <div
              className="form-group m-t-10  col-md-6"
              style={{ float: "left" }}
            >
              <div className="col-md-12">
                <select name="role" className="form-control" onChange={(e) => setRole(e.target.value)}>
                  <option value="">--Select User Role--</option>
                  <option value="1">Purchase Order</option>
                  <option value="2">Purchase Enquiry</option>
                  <option value="3">Admin</option>
                  <option value="4">Super Admin</option>
                  <option value="5">Miro Print</option>
                  <option value="6">Store</option>
                  <option value="7">Material</option>
                  <option value="22">
                    Procurement Approval
                  </option>
                </select>{" "}
              </div>
            </div>
            <div
              className="form-group m-t-10  col-xs-6"
              style={{ float: "left" }}
            >
              <div className="col-md-12">
                <button
                  style={{
                    padding: "5px 10px",
                    border: "none",
                    background: "rgb(0, 123, 255)",
                    color: "rgb(255, 255, 255)",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
          </form>
        </div>
      </div>
      {showPopup && (
        <div
          className="mainParentModal"
          style={{ textAlign: "center", margin: "5px 0 20px 0" }}
        >
          <div className="popup-overlay">
            <div className="popup-box">
              <h3>Generate Password</h3>
              <p>
                <strong>Email:</strong> {selectedData.email}
              </p>
              {/* <p>
              <strong>User ID:</strong> {selectedData.id}
            </p> */}
              <input
                type="password"
                name="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
                style={{ marginRight: "10px" }}
              />{" "}
              <input
                type="text"
                name="confirmpassword"
                id="confirmpassword"
                value={confirmpassword}
                onChange={(e) => setConfirmpassword(e.target.value)}
                placeholder="Re-enter password"
              />
              <button
                onClick={() =>
                  updatePassword(selectedData.id, selectedData.email)
                }
                style={{ marginLeft: "10px" }}
              >
                Update
              </button>
              <button
                onClick={() => setShowPopup(false)}
                style={{ marginLeft: "10px" }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row page-titles">
            <div className="col-md-5 align-self-center">
              <h4 className="text-themecolor">User List</h4>
            </div>
            <div className="col-md-7 align-self-center text-end">
              <div className="d-flex justify-content-end align-items-center">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0)">Home</a>
                  </li>
                  <li className="breadcrumb-item active">User List</li>
                </ol>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div>
                    <input
                      type="text"
                      placeholder="Search.."
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      style={{
                        width: "30%",
                        padding: "10px",
                        fontSize: "16px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        float: "right",
                      }}
                    />
                  </div>

                  <DataTable
                    columns={columns}
                    data={filtered}
                    pagination
                    paginationServer={false}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={filtered.length}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={loading}
                    progressComponent={
                      <div style={{ color: "Green", fontSize: "35px" }}>
                        Loading User List....
                      </div>
                    }
                    highlightOnHover
                    persistTableHead
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Right sidebar left as-is */}
        </div>
      </div>
    </>
  );
};

export default UserList;
